import React from 'react';
import { useLocation } from 'react-router-dom';
import { CloudClevrLogoIcon } from '../../../components/ui/Icons';
import styles from './styles.module.css';
import { Card } from '@cloudclevr/components';
import LogoElement from '@assets/svg/logo_element.svg';
import { PageHeader } from '@components/partials';

type Props = {
  customTitle?: string;
};

type LocationState = {
  lastRoadmap?: {
    id?: string | number;
    name?: string;
    status?: number;
    [key: string]: any;
  };
};

const RoadmapsDraftPage: React.FC<Props> = ({ customTitle }) => {
  const location = useLocation();
  const state = location.state as LocationState | null;
  const lastRoadmap = state?.lastRoadmap;
  return (
    <>
            <PageHeader customTitle={lastRoadmap?.name} /> 

            <div className="flex justify-center">
              <Card classNames="flex flex-col items-center text-center p-6 px-[148px] pt-[80px] pb-[96px] mt-7 w-[778px]">
                <img
                  src={LogoElement}
                  alt="CloudClevr logo"
                  width={57}
                  className="mb-4"
                />

                <h2 className={styles.card_title}>
                  We&apos;re working on your roadmap 
                </h2>

                <p className={styles.card_subtitle}>
                  We&apos;ve temporarily removed your roadmap while we make some changes. Check back soon for updates.
                </p>
              </Card>
            </div>
    </>
  );
};

export { RoadmapsDraftPage };